import React, {Component} from 'react';
import {
  Clear as ClearIcon,
  AccessTime as TimeIcon
} from "@material-ui/icons";
import { IconButton, InputAdornment } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import "moment/locale/pt-br";

const styles = theme => ({
 
  floatingLabelFocusStyle: {
    //flexGrow: 1,
    height: 0,
    //position: 'relative',
    //marginTop: 15
  },

  root: {
    backgroundColor: '#f9f9f9'
  },
})

class IntegrationTimePicker extends Component {
  state = {
    locale: "pt-br",
  };

  handleDateChange = (date) => {
    const name = this.props.name;
    // Format to HH:mm string for the parent
    const value = date ? moment(date).format('HH:mm') : '';
    
    if (this.props.onChange) {
        // Simulate event object pattern used in the app
        this.props.onChange({ target: { name, value } });
    }
  };

  handleonDateClear = e => {
    e.stopPropagation();
    const name = this.props.name;
    if (this.props.onChange) {
        this.props.onChange({ target: { name, value: '' } });
    }
  };

  handleAbort = () => {
     // No-op or specific logic if needed
  }

  render() {
    const {classes} = this.props;
    const {locale} = this.state;
    
    // Parse input value (string HH:mm) to moment object
    let value = this.props.valor;
    if (value && typeof value === 'string') {
        // Try parsing HH:mm
        const m = moment(value, 'HH:mm');
        value = m.isValid() ? m : null;
    } else if (!value) {
        value = null;
    }

    return (<div key="basic_time" className="picker">
      <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
      <KeyboardTimePicker
        disableToolbar
        variant="inline"
        inputVariant="filled"
        className={classes.root}
        fullWidth
        label={this.props.labelTimePicker}
        margin="normal"
        size="small"
        value={value}
        onChange={this.handleDateChange}
        ampm={false}
        onClose={this.handleAbort}
        style={{ backgroundColor: '#00000000' }}
        keyboardIcon={<TimeIcon />}
        InputLabelProps={{
          className: classes.floatingLabelFocusStyle,
          shrink: true,
        }}
        InputProps={{
          disableUnderline: true,
          endAdornment: value !== null ? (
            <InputAdornment position="end">
              <IconButton onClick={this.handleonDateClear}>
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        }}                
      />
      </MuiPickersUtilsProvider>

    </div>)
  }
}

IntegrationTimePicker.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IntegrationTimePicker);
